import * as React from 'react';

function SvgLocation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 15.96 23.92" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M15.96 7.99a6.46 6.46 0 01-.52 2.79l-5.67 12a1.93 1.93 0 01-.74.81 2 2 0 01-1.05.3 2 2 0 01-1-.3 1.84 1.84 0 01-.73-.81l-5.68-12a6.46 6.46 0 01-.61-2.79 7.69 7.69 0 012.38-5.65A7.69 7.69 0 017.96-.01a7.69 7.69 0 015.64 2.34 7.69 7.69 0 012.36 5.66zm-5.16 2.82a3.84 3.84 0 001.16-2.82 3.84 3.84 0 00-1.17-2.82 3.84 3.84 0 00-2.83-1.18 3.84 3.84 0 00-2.8 1.17 3.84 3.84 0 00-1.2 2.83 3.84 3.84 0 001.2 2.81 3.83 3.83 0 002.8 1.19 3.83 3.83 0 002.84-1.19z" />
    </svg>
  );
}

const MemoSvgLocation = React.memo(SvgLocation);
export default MemoSvgLocation;
